export default function Process({ data }) {
  const label = data?.label || "How we work";
  const headline = data?.headline || "A calm process for a beautiful celebration.";
  const subheadline = data?.subheadline || "";
  const steps = data?.steps || [];

  return (
    <section id="process" data-testid="process-section" className="bg-sage/40 py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-12 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <div className="reveal flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-gold" />
              <span className="eyebrow">{label}</span>
            </div>
            <h2
              data-testid="process-headline"
              className="reveal font-display text-[2.25rem] leading-[1.05] sm:text-5xl md:text-6xl tracking-tight text-charcoal"
            >
              {headline}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:pl-6 self-end">
            <p className="reveal text-base md:text-lg font-light text-charcoal/75 leading-relaxed">
              {subheadline}
            </p>
          </div>
        </div>

        <ol className="relative">
          <span className="absolute left-4 md:left-1/2 top-2 bottom-2 w-px bg-gold/40 hidden md:block" aria-hidden />

          {steps.map((s, i) => {
            const right = i % 2 === 1;
            return (
              <li
                key={s.step}
                data-testid={`process-step-${i}`}
                className="reveal relative grid grid-cols-12 gap-4 md:gap-10 py-7 md:py-10"
              >
                <div className="md:hidden col-span-12 flex items-start gap-5">
                  <Marker step={s.step} />
                  <div>
                    <h3 className="font-display text-2xl text-charcoal">{s.title}</h3>
                    <p className="mt-2 text-charcoal/70 font-light leading-relaxed">{s.description}</p>
                  </div>
                </div>

                <div className={`hidden md:flex col-span-5 ${right ? "order-3 justify-start pl-12" : "justify-end pr-12 text-right"}`}>
                  <div className="max-w-sm">
                    <h3 className="font-display text-3xl text-charcoal">{s.title}</h3>
                    <p className="mt-3 text-charcoal/70 font-light leading-relaxed">{s.description}</p>
                  </div>
                </div>
                <div className="hidden md:flex col-span-2 justify-center">
                  <Marker step={s.step} />
                </div>
                <div className={`hidden md:block col-span-5 ${right ? "order-1" : "order-3"}`} />
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

function Marker({ step }) {
  return (
    <div className="flex flex-col items-center">
      <span className="h-9 w-9 md:h-12 md:w-12 rounded-full bg-ivory border border-gold flex items-center justify-center font-display text-gold text-base md:text-lg">
        {step}
      </span>
    </div>
  );
}
